import { useCallback, useEffect, useState } from "react";
import { getCalidadSuministradoresHomologados } from "../api/suministradores-homologados";
import type { CalidadControlModificacion } from "../../../types/control-modificaciones";
import type { CalidadSuministradoresHomologadosData } from "../types/suministradores-homologados";

const emptyData: CalidadSuministradoresHomologadosData = {
  indirectos: [],
  directos: [],
  grupo: [],
};

export function useCalidadSuministradoresHomologados(enabled = true) {
  const [data, setData] = useState<CalidadSuministradoresHomologadosData>(emptyData);
  const [controlModificaciones, setControlModificaciones] = useState<
    CalidadControlModificacion[]
  >([]);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    if (!enabled) {
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await getCalidadSuministradoresHomologados();
      setData(response.data);
      setControlModificaciones(response.control_modificaciones);
    } catch {
      setError(
        "No se pudo cargar la seccion de suministradores homologados.",
      );
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return;
    }

    void reload();
  }, [enabled, reload]);

  return {
    data,
    loading,
    error,
    reload,
    setData,
    controlModificaciones,
  };
}
